<div class="l-core-contents__tabpanel is-current" id="panel-1" role="tabpanel" aria-labelledby="tab1" tabindex="0">
  <div class="l-core-contents__inner">
    <div class="l-core-contents__main">
      <div class="l-section u-mt-sp-20 u-mt-tb-24 u-mt-pc-48">
        <asw-trip-summary></asw-trip-summary>
        <asw-fare-rules [functionList]="functionList" *ngIf="isShowFareRules"></asw-fare-rules>
      </div>

      <div class="l-section u-mt-sp-32 u-mt-tb-40 u-mt-pc-56">
        <asw-baggage-rules [functionList]="functionList"></asw-baggage-rules>
      </div>
    </div>
    <div class="l-core-contents__sub">
      <asw-my-booking-payment [functionList]="functionList"></asw-my-booking-payment>
    </div>
  </div>
</div>
